export default __webpack_public_path__ + "static/media/qms_back_home_btn.f1d15583.svg";